import { HttpParams } from "@angular/common/http";
import { PaginatedSearch } from "../models/PaginatedSearch";

export class BaseService {

    constructor() { }

    toHttpParams(criteria?: PaginatedSearch) {
        let httpParams = new HttpParams();

        if (criteria) {
            for (let [key, value] of Object.entries(criteria)) {
                if (value) httpParams = httpParams.append(key, value);
            }
        }

        return httpParams;
    }
}